enum OrderItemType {
  STANDARD = "standard",
  PROMOTIONAL = "promotional",
  WARRANTY_REPLACEMENT = "warranty_replacement",
  TRIAL = "trial",
}

export default OrderItemType
